module.exports = __webpack_public_path__ + "static/media/cloud.5eb8d5ff.svg";